module.exports = __webpack_public_path__ + "img/9788994142654.6a75855d.jpg";